// Clients & requests (firm-wide): every request, program question and follow-up with every client of the engagements you can
// see, as threads — the same workspace as an engagement's Client tab, across engagements, with bulk send / remind.
import { useApp } from "../app/context";
import { LoadState, PageHeader } from "../components";
import { useLoad } from "../lib/hooks";
import { ThreadWorkspace } from "./client/ThreadWorkspace";

export function RequestsPage() {
  const { ds } = useApp();
  const es = useLoad(() => ds.engagements(), [ds]);
  return (
    <div className="mx-auto max-w-7xl">
      <PageHeader title="Clients & requests" subtitle="Requests, program questions and follow-ups with every client, with the engine's status. Nothing reaches a client until a person sends it." />
      <LoadState state={es}>
        {(list) => <ThreadWorkspace engagements={list.map((e) => ({ id: e.id, name: e.clientName }))} showClient />}
      </LoadState>
    </div>
  );
}
